<!--
 * @Description: 
-->
<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.classStatus"
        placeholder="班级状态"
      >
        <el-option
          v-for="(item, i) in classStatusData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn_170">
      <el-cascader
        class="select_btn_style"
        v-model="filters.trainTypes"
        :options="trainTypeData"
        :props="props"
        collapse-tags
        placeholder="培训类型"
      >
      </el-cascader>
    </el-form-item>
    <!--<el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.classLevel"
        placeholder="办班级别"
      >
        <el-option
          v-for="(item, i) in classTypeData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>-->
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        size="small"
        v-model.trim="filters.className"
        placeholder="班级名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";

import {
  treeChildVos,
} from "@/api/classOffline";

export default {
  components: { butn },
  data() {
    return {
      props: {
        //树形
        multiple: true,
        value: "key",
        label: "name",
        children: "children",
        // checkStrictly: true,
      },
      filters: {},
      classTypeData: [],
      trainTypeData: [],
      classStatusData: [],
    };
  },
  created() {
    this.getSysParamByTypes(["CLASS_LEVEL_TYPE", "CLASS_STATUS"]);
    // CLASS_TYPE_DOWN CLASS_TYPE_UP
    treeChildVos({ type: "CLASS_TYPE_DOWN" }).then((res) => {
      let goal = [];
      if (!res || res.code != 0) return;
      goal = res.data;
      this.trainTypeData = goal
    });
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        res.data["CLASS_LEVEL_TYPE"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["CLASS_STATUS"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        this.classTypeData = res.data["CLASS_LEVEL_TYPE"];
        this.classStatusData = res.data["CLASS_STATUS"];
      });
    },
    initData() {
      const filters = { ...this.filters }
      if (filters.trainTypes && filters.trainTypes.length) {
        const trainTypes = new Set()
        filters.trainTypes.forEach(item => {
          trainTypes.add(item[1])
        })
        filters.trainTypes = Array.from(trainTypes)
      }
      this.$emit("search", { ...filters, t: new Date().getTime() });
    },
    resetData() {
      this.filters = {};
      this.initData();
    },
  },
};
</script>

<style lang="scss" scoped>
.serach-form {
  text-align: right;
}
</style>
